import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service';

/**
 * Settings-section page for `[dbo].[Variables]` — route `/edit-variable`
 * (owner request, 2026-09-14, after `VariableSelectorComponent`'s popup
 * Delete surfaced a variable referenced by 59,017 vendor price formulas: a
 * case like that needs a searchable page, not a dropdown dialog). Thin
 * shell matching `EditUserAccessComponent`/`AgentSetupComponent`'s own
 * `p-panel` + `p-accordion` shape — the real list/add/edit/delete table
 * lives in `EditPriceVariablesTabComponent`, kept separate the same reason
 * every other settings CRUD table in this app is its own `edit-*-tab`
 * component (reusable, testable independent of the page shell).
 *
 * Route-level `data.roles` (`app-routing.module.ts`) already gates
 * navigation; this component-level check is defense-in-depth against a
 * direct URL hit, same pattern `EditUserAccessComponent`/`AgentSetupComponent`
 * already use.
 */
@Component({
  selector: 'app-edit-variable',
  templateUrl: './edit-variable.component.html',
  styleUrls: ['./edit-variable.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditVariableComponent implements OnInit {

  windowsTitle: string = 'Ценовые переменные';

  /** `true` when the user meets the role bar this page's route also
   *  requires (`can-manage-products` or `portal-admin`) — mirrored here
   *  rather than trusted from routing alone, matching
   *  `EditUserAccessComponent`'s own "prevent direct URL access" check. */
  public canAccessPage: boolean = false;

  constructor(
    private globalsettingsservice: GetglobalsettingsService,
    private titleService: Title,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.canAccessPage = this.globalsettingsservice.hasSomeRoles('can-manage-products', 'portal-admin');

    if (!this.canAccessPage) {
      alert('У вас недостаточно прав для доступа к этой странице.');
      this.router.navigate(['/']);
      return;
    }

    this.titleService.setTitle(this.windowsTitle);
  }
}
